import { css } from '@emotion/react';

const chargeProcessStyles = {
    container: css({
        display: 'flex',
        flexDirection: 'column',

        '@media (min-width: 600px)': {
            zIndex: 10000,
        },
    }),
    actions: css({
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        marginTop: '12px',
        width: '100%',
    }),
    containerTitle: css({
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '16px',
        lineHeight: '23px',
        color: '#000000',
        margin: '15px 0px 0 0px',
        display: 'flex',
        alignItems: 'center',
    }),
    content: css({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
    }),
    state: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        position: 'relative',
    }),
    statePower: css({
        fontSize: '3.125rem',
        fontWeight: 800,
        textAlign: 'center',
        color: '#101010',
        position: 'relative',
    }),
    statePowerValue: css({
        padding: '0 1rem',
        letterSpacing: '-1.5px',
    }),
    statePowerUnit: css({
        fontSize: '1.5rem',
        fontWeight: 300,
        letterSpacing: '-0.75px',
    }),
    statePowerInfo: css({
        fontSize: '1rem',
        fontWeight: 800,
        color: '#101010',
    }),
    blinker: css({
        width: 13,
        height: 13,
        backgroundColor: '#00FF8080',
        borderRadius: '50%',
        // margin: 0,
        marginRight: 8,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        animation: 'blink 3s infinite',
        '@keyframes blink': {
            ['0%, 100%']: {
                opacity: 1,
            },
            ['50%']: {
                opacity: 0,
            },
        },
    }),
    blinkerInner: css({
        width: 11,
        height: 11,
        backgroundColor: '#00FF45',
        borderRadius: '50%',
        display: 'inline-block',
    }),
    businessCardInfo: css({
        color: '#000000',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        paddingTop: '10px',

        '@media (min-width: 600px)': {
            paddingTop: '0',
        },
    }),
    businessCardInfoInnerContainer: css({
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
    }),
    businessCardInfoTitle: css({
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '20px',
        lineHeight: '24px',
        color: '#000000',
    }),
    transactionDate: css({
        fontWeight: 300,
        fontSize: '13px',
        lineHeight: '14px',
        color: '#000000',
    }),
    arrowRight: css({
        display: 'none',

        '@media (min-width: 600px)': {
            display: 'block',
            cursor: 'pointer',
        },
    }),
    arrowRightIcon: css({
        width: '24px',
    }),
};
export default chargeProcessStyles;
